














































import {Component, Prop, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import Editor from '@tinymce/tinymce-vue';
import {ActionsEnum} from "@/entity/ActionsEnum";
import Seo from "@/components/inputs/Seo.vue";


class Detay {
  product_id: any | undefined = undefined;
  detay_id: Number | undefined = undefined;
  title: String | undefined = "";
  context_data: String | undefined = "";
}


@Component({
  components: {
    Seo,
    DeleteButton, EForm, Number, TextField, Id, Editor
  }
})

export default class ProductDetail extends Vue {

  @Prop({})
  UrunId!: number;

  items: Detay[] | null = null;
  dialog = false;
  product_id: any | null = null;
  title: string = "";
  search: string = "";
  baseAction: string = ActionsEnum.UrumDetay;
  action: string = this.baseAction;


  data: Detay = new Detay();
  headers = [
    {
      text: "Id",
      align: "start",
      sortable: true,
      value: "detay_id"
    },
    {text: "Başlık", value: "title"},
    {text: "İşlemler", value: "actions"}
  ];

  /*
  TODO Sayfalar nerde konumlanacak footer vs ekle ..
      persistent ayarlari yapilacak modal belki yeni component olabilir
   */
  edit(item: Detay) {
    this.title = "Düzenle";
    this.data = item;
    this.action = this.baseAction + "/" + item.detay_id;
    this.dialog = true;
    this.dialog = true;
  }

  dialogClick(e: Event) {
    console.log("event", e);
    e.preventDefault();

  }

  add() {
    this.title = "Ekle";
    this.data = new Detay();
    this.data["product_id"]=this.UrunId
    this.action = this.baseAction;
    this.dialog = true;
  }

  async get() {
    this.dialog = false;
    let response = await this.$http.get(this.baseAction);
    this.items = response.data;
  }

  created() {
    this.get();
  }
};
